import { EditTextChange } from "@/store/zustand/changeLedgerTypes";
import { getElementsForCodebaseId } from "./domUtils";
import { ApplyInstantUpdateProps } from "./utils";

export const applyEditTextChange = (
  props: ApplyInstantUpdateProps,
): boolean => {
  const { iframeDocument: iframeDoc, storyboardId, persistentData } = props;
  const change = props.change as EditTextChange;
  const { codebaseIdToEditText, newText } = change.changeFields;

  // Find all elements with this codebase ID
  const elements = getElementsForCodebaseId(iframeDoc, codebaseIdToEditText);

  if (elements.length === 0) {
    console.warn(
      `Could not find element with codebase ID ${codebaseIdToEditText} for text edit`,
    );
    return false;
  }

  persistentData.storyboardsAppliedTo.add(storyboardId);

  // Update text content for all matching elements
  elements.forEach((element) => {
    element.textContent = newText;
  });

  return true;
};

export const undoEditTextChange = (props: ApplyInstantUpdateProps): boolean => {
  const { iframeDocument: iframeDoc } = props;
  const change = props.change as EditTextChange;
  const { codebaseIdToEditText, oldText } = change.changeFields;

  if (!oldText) {
    console.warn("No old text provided for undo");
    return false;
  }

  // Find all elements with this codebase ID
  const elements = getElementsForCodebaseId(iframeDoc, codebaseIdToEditText);

  if (elements.length === 0) {
    console.warn(
      `Could not find element with codebase ID ${codebaseIdToEditText} for text edit undo`,
    );
    return false;
  }

  // Restore original text content for all matching elements
  elements.forEach((element) => {
    element.textContent = oldText;
  });

  return true;
};
